import { Fleet } from '@src/main/modules/parameters/domain/fleet-positions/fleet.interface';

export interface UpdateFleetPositionsRequest {
  positions: string[];
}

export const fleetPositionsRequestFromFleet = (fleet: Fleet): UpdateFleetPositionsRequest => ({
  positions: fleet.positions.map((p) => p.positionId),
});
